import { LanguageMessagesConstantsOneSignalInit } from '@/types/constants/types';

const oneSignalInit: LanguageMessagesConstantsOneSignalInit = {
  en: {
    title:
      'We would like to show you notifications for the latest news and updates.',
    allow: 'Allow',
    cancel: 'No thanks',
  },
  de: {
    title:
      'Wir möchten Ihnen Benachrichtigungen zu den neuesten Nachrichten und Updates anzeigen.',
    allow: 'Erlauben',
    cancel: 'Nein, danke',
  },
  it: {
    title:
      'Vorremmo mostrarti le notifiche per le ultime notizie e aggiornamenti.',
    allow: 'Permettere',
    cancel: 'No, grazie',
  },
  es: {
    title:
      'Nos gustaría mostrarte notificaciones para las últimas noticias y actualizaciones.',
    allow: 'Permitir',
    cancel: 'No, gracias',
  },
  fr: {
    title:
      'Nous aimerions vous montrer des notifications pour les dernières nouvelles et mises à jour.',
    allow: 'Permettre',
    cancel: 'Non merci',
  },
};

const languageMessagesConstants = {
  oneSignalInit,
};
export default languageMessagesConstants;
